import type {GetEntrySheetResponse} from '../../../core/repositories/reportsRepository';

export type ListEntrySheetQuestionAnswer = {
  question_list: Array<{
    label: string;
    value: string;
  }>;
  answer: string;
};

export const listEntrySheetQuestionAnswer = (
  entrySheet: GetEntrySheetResponse,
) => {
  return entrySheet.questionAnswers.map((questionAnswer) => {
    return {
      question_list: [
        {
          label: '質問項目',
          value: questionAnswer.question,
        },
        {
          label: '指定文字数',
          value: `${
            questionAnswer.remarks ? questionAnswer.remarks : '指定なし'
          }`,
        },
      ],
      answer: questionAnswer.answer,
    };
  });
};
